import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronRight, X } from 'lucide-react';
import { MORE_GROUPS } from '../lib/navItems.js';

export default function MoreSheet({ open, onClose, items }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-black/30 transition-opacity duration-200 lg:hidden ${
          open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        aria-hidden
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Toutes les pages"
        aria-hidden={!open}
        className={`fixed inset-x-0 bottom-0 z-50 max-h-[85dvh] overflow-y-auto rounded-t-2xl bg-white shadow-2xl lg:hidden transition-[transform,visibility] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${
          open ? 'translate-y-0 visible' : 'translate-y-full invisible'
        }`}
        style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between bg-white px-4 pb-2 pt-3">
          <h2 className="text-base font-semibold text-slate-900">Toutes les pages</h2>
          <button
            type="button"
            onClick={onClose}
            className="-mr-2 flex h-11 w-11 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100"
            aria-label="Fermer"
          >
            <X size={20} aria-hidden />
          </button>
        </div>

        {MORE_GROUPS.map((group) => {
          const groupItems = items.filter((i) => i.group === group);
          if (groupItems.length === 0) return null;
          return (
            <section key={group} className="px-4 pt-3">
              <h3 className="px-1 pb-1.5 text-xs font-semibold uppercase tracking-wide text-slate-400">
                {group}
              </h3>
              <ul className="divide-y divide-slate-100 overflow-hidden rounded-xl bg-slate-50">
                {groupItems.map(({ to, label, Icon }) => (
                  <li key={to}>
                    <NavLink
                      to={to}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `flex min-h-12 items-center gap-3 px-3 text-[15px] font-medium active:bg-slate-100 ${
                          isActive ? 'text-slate-900' : 'text-slate-700'
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <span
                            className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                              isActive ? 'bg-slate-800 text-white' : 'bg-white text-slate-600'
                            }`}
                          >
                            <Icon size={17} aria-hidden />
                          </span>
                          <span className="flex-1">{label}</span>
                          <ChevronRight size={16} className="text-slate-300" aria-hidden />
                        </>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </>
  );
}
